export var OfflineDisabled = null;
//# sourceMappingURL=offline.js.map